import { exportTopics } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { SaveAlt } from "@mui/icons-material";
import { useMutation } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

/**
 * TopicsExportButton component - Exports all topics to Excel
 */
export const TopicsExportButton = () => {
    const { mutate, isPending } = useMutation<Blob, Error>({
        mutationFn: () => exportTopics(),
        onSuccess: (blob) => {
            downloadFile(blob);
            enqueueSnackbar("Topics exported successfully", {
                variant: "success",
            });
        },
        onError: () => {
            enqueueSnackbar("An error occurred while exporting topics", {
                variant: "error",
            });
        },
    });

    const downloadFile = (blob: Blob) => {
        const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const url = window.URL.createObjectURL(
            new Blob([blob], { type: mimeType })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "topics_export.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    return (
        <Button
            type="button"
            variant="outlined"
            disableElevation
            sx={{ borderRadius: 22 }}
            startIcon={<SaveAlt />}
            onClick={() => mutate()}
            loading={isPending}
            loadingPosition="start"
        >
            {isPending ? "Exporting..." : "Export"}
        </Button>
    );
};
